import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class Validation {
  static PasswordMatch(password, confirmPassword): ValidatorFn {
    return (controls: AbstractControl): ValidationErrors | null => {
      const control = controls.get(password);
      const checkControl = controls.get(confirmPassword);
      const errors = checkControl.errors ?? {};

      // if (checkControl?.errors && !checkControl.errors['matching']) {
      //   return null;
      // }

      if (control?.value !== checkControl?.value) {
        errors['matching'] = true;
        checkControl?.setErrors(errors);
        return { matching: true };
      } else {
        return null;
      }
    };
  }

  static Different(field1: string, field2: string): ValidatorFn {
    return (controls: AbstractControl): ValidationErrors | null => {
      const control = controls.get(field1);
      const checkControl = controls.get(field2);
      const errors = checkControl.errors ?? {};

      if (control?.value === checkControl?.value) {
        errors['Different'] = true;
        checkControl?.setErrors(errors);
        return { Different: true };
      } else {
        return null;
      }
    };
  }

  static StrongPassword(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value) return null;

    const errors: Record<string, boolean> = control.errors ?? {};

    errors['UpperCase'] = !value.match(/^(?=.*[A-Z])/);
    errors['LowerCase'] = !value.match(/(?=.*[a-z])/);
    errors['Number'] = !value.match(/(.*[0-9].*)/);
    errors['SpecialCharacter'] = !value.match(/(?=.*[!@#$%^&*])/);
    errors['Length'] = !value.match(/.{13,}/);

    const isValid = !errors['UpperCase'] && !errors['LowerCase'] && !errors['Number'] && !errors['SpecialCharacter'] && !errors['Length'];

    if (isValid) return null;

    return errors;
  }
}
